import React from "react";
import { Typography } from "antd";
import Text from "antd/lib/typography/Text";

import ACButton from "ac-components/ac-button/ACButton";
import ACButtonGroup, { ACButtonGroupItem } from "ac-components/ACButtonGroup";
import ACDropdown from "ac-components/ACDropdown";
import ACMiddleEllipsis from "ac-components/ac-middle-ellipsis/ACMiddleEllipsis";
import AnyaHistoryMenuIcon from "ac-components/ac-icons/AnyaHistoryMenuIcon";
import ChevronDownIcon from "ac-components/ac-icons/ChevronDownIcon";
import EllipsisVerticalIcon from "ac-components/ac-icons/EllipsisVerticalIcon";
import PlusIcon from "ac-components/ac-icons/PlusIcon";
import TrashIcon from "ac-components/ac-icons/TrashIcon";

import { AnyaSessionMode } from "types/anya";

import AnyaAgentSwitcher from "./AnyaAgentSwitcher";

const SWITCHER_BUTTON_WIDTH = 170;
const LEGACY_ANYA_INSIGHTS_LABEL = "Anya Insights";

export default function AnyaModalHeader({
    agentOptions,
    chatId,
    isAnyaAgentsEnabled,
    onCreateNewChat,
    onDeleteConversation,
    onSelectAgent,
    onSelectChat,
    searchAgents,
    selectedAgent,
    sessionMode,
    toggleHistory,
}) {
    const items = [
        {
            label: <div className="d-flex align-items-center  danger"><TrashIcon className="font-size-24 m-r-xs" /><Text className="danger">Delete</Text></div>,
            value: "delete",
            disabled: chatId === null,
        },
    ];

    const onDropDownOptionClick = (value) => {
        if (value === "delete") {
            onDeleteConversation(chatId);
        }
    };

    return (
        <div className="d-flex align-items-center justify-content-between w-100">
            <div className="d-flex align-items-center flex-1 overflow-hidden" style={{ minWidth: 0 }}>
                <AnyaHistoryMenuIcon onClick={toggleHistory} className="m-r-xs clickable" />
                {isAnyaAgentsEnabled ? (
                    <AnyaAgentSwitcher
                        agentOptions={agentOptions}
                        searchAgents={searchAgents}
                        selectedAgent={selectedAgent}
                        selectedMode={sessionMode}
                        onSelectAgent={onSelectAgent}
                        onSelectChat={onSelectChat}
                        allowChatOption
                        menuWidth={220}
                        itemTextWidth={190}
                    >
                        {({ mode, selectedLabel }) => (
                            <ACButton
                                type="ghost"
                                rightIcon={<ChevronDownIcon className="color-supporting" />}
                                className="text-left overflow-hidden"
                            >
                                {mode === AnyaSessionMode.CHAT ? (
                                    <span className="text-bold white-space-nowrap">{selectedLabel}</span>
                                ) : (
                                    <div className="d-flex align-items-center overflow-hidden" style={{ minWidth: 0 }}>
                                        <span className="text-bold white-space-nowrap">Agent:</span>
                                        <span className="m-l-xs overflow-hidden" style={{ width: SWITCHER_BUTTON_WIDTH, maxWidth: "100%" }}>
                                            <ACMiddleEllipsis text={selectedLabel} applyWidth />
                                        </span>
                                    </div>
                                )}
                            </ACButton>
                        )}
                    </AnyaAgentSwitcher>
                ) : (
                    <Typography.Text>{LEGACY_ANYA_INSIGHTS_LABEL}</Typography.Text>
                )}
            </div>
            <ACButtonGroup size="md">
                <ACDropdown items={items} onOptionClick={onDropDownOptionClick}>
                    <ACButtonGroupItem id="more-actions">
                        <EllipsisVerticalIcon />
                    </ACButtonGroupItem>
                </ACDropdown>
                <ACButtonGroupItem onClick={() => onCreateNewChat()}>
                    <PlusIcon />
                </ACButtonGroupItem>
            </ACButtonGroup>
        </div>
    );
}
